import { Dispatch, createContext, useContext, useState } from 'react';

interface IAppointmentContextObject {
  businessId: number;
  businessEmployeeId?: number;
  serviceId?: number;
}

interface IAppointmentContextData {
  appointment?: IAppointmentContextObject;
  setAppointment: Dispatch<React.SetStateAction<IAppointmentContextObject | undefined>>;
  viaScheduler: boolean;
  setViaScheduler: Dispatch<React.SetStateAction<boolean>>;
  walkIn: boolean;
  setWalkIn: Dispatch<React.SetStateAction<boolean>>;
  blockBusiness: boolean;
  setBlockBusiness: Dispatch<React.SetStateAction<boolean>>;
  blockEmployee: boolean;
  setBlockEmployee: Dispatch<React.SetStateAction<boolean>>;
}

const AppointmentContext = createContext({} as IAppointmentContextData);

export const useAppointmentContext = () => {
  return useContext(AppointmentContext);
};

type Props = {
  children?: React.ReactNode,
};

export const AppointmentProvider: React.FC<Props> = ({ children }) => {
  const [appointment, setAppointment] = useState<IAppointmentContextObject>();
  const [viaScheduler, setViaScheduler] = useState(false);
  const [walkIn, setWalkIn] = useState(false);
  const [blockBusiness, setBlockBusiness] = useState(false);
  const [blockEmployee, setBlockEmployee] = useState(false);

  return (
    <AppointmentContext.Provider value={{
      appointment,
      setAppointment,
      viaScheduler,
      setViaScheduler,
      walkIn,
      setWalkIn,
      blockBusiness,
      setBlockBusiness,
      blockEmployee,
      setBlockEmployee
    }}>
      {children}
    </AppointmentContext.Provider>
  );
};
